


























import { Component, Vue } from 'vue-property-decorator';
import { fetchHealthCheck } from '@/services/common';

interface HealthCheckResponse {
  code: number;
  message: string;
  data: any;
  duration?: number;
}

@Component
export default class HealthCheck extends Vue {
  private status: 'success' | 'error' | 'loading' = 'loading';
  private duration: number = 0;
  private isOnline: boolean = navigator.onLine;
  private checkInterval: number | null = null;

  get tooltipContent(): string {
    const statusText = !this.isOnline
      ? (this.$t('components.health-check.text_7f517edc79bb7ebf') as string)
      : this.status === 'success'
        ? (this.$t('components.health-check.text_6b635e38') as string)
        : this.status === 'error'
          ? (this.$t('components.health-check.text_5f025e38') as string)
          : (this.$t('components.health-check.text_68c067e54e2d') as string);
    const durationText = this.isOnline && this.status !== 'error' ? `(${this.duration}ms)` : '';
    return this.$t('components.health-check.text_670d52a172b66001', { status: statusText, duration: durationText }) as string;
  }

  mounted() {
    // 添加网络状态监听
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);

    // 初始检查
    this.checkHealth();

    // 每30秒检查一次
    this.checkInterval = window.setInterval(this.checkHealth, 30000);
  }

  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.handleOffline);

    // 清除定时器
    if (this.checkInterval !== null) {
      clearInterval(this.checkInterval);
    }
  }

  private handleOnline() {
    this.isOnline = true;
  }

  private handleOffline() {
    this.isOnline = false;
  }

  private async checkHealth() {
    if (!this.isOnline) {
      this.status = 'error';
      return;
    }

    try {
      const result = (await fetchHealthCheck()) as HealthCheckResponse;
      this.status = result.code === 0 || result.code === 200 ? 'success' : 'error';
      this.duration = result.duration || 0;
    } catch (error) {
      this.status = 'error';
    }
  }
}
